/* eslint-disable max-len */

import 'chartjs-adapter-moment';
import { Line } from 'react-chartjs-2';
import "chart.js/auto";
import { useSelector } from 'react-redux';
import moment from "moment-timezone";
import { convertToPatientTimeZoneDateFormat } from '../../../../../CommonMethods/ConvertDatetoPatientTimezone';


export default function LineChart({ graphDetails, label, from ,unit}) {
const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)


function convertToDecimalHours(timestamp, timezone) {
    // Convert the timestamp to the specified timezone
    let date = moment.tz(timestamp, timezone);
    
    // Extract hours and minutes in the target timezone
    let hours = date.hours();
    let minutes = date.minutes();

    // Convert minutes to a decimal part of an hour
    let decimalMinutes = minutes / 60;
  
    // Combine hours and decimal minutes
    let decimalHours = hours + decimalMinutes;
    // Return 0.00 for midnight (12:00 AM) instead of 24.00 - treat as start of day
    // Return numeric value instead of string to ensure proper Chart.js sorting
    return decimalHours === 0 ? 0.00 : parseFloat(decimalHours.toFixed(2));
}

 

    

  const dataType = from;
  let datasets = [];

  if (graphDetails && graphDetails[dataType]) {
      const dataValues = graphDetails[dataType];

      // If it's blood_pressure, handle systolic and diastolic readings
      if (dataType === 'blood_pressure' && dataValues.systolic && dataValues.diastolic) {
          // Sort by timestamp first, then convert and sort by x-value
          const sortedSystolic = [...dataValues.systolic].sort((a, b) => a.timestamp - b.timestamp);
          let systolicData = sortedSystolic.map(entry => ({x:convertToDecimalHours(entry.timestamp*1000,entry.timezone),y:entry.reading,m:entry.timestamp,unit:entry.unit,timezone:entry.timezone}));
          // Sort by x-value (decimal hours) to ensure Chart.js receives data in ascending order
          systolicData = systolicData.sort((a, b) => a.x - b.x);
          
          datasets.push({
              data: systolicData,
              borderColor: "#006A6B",
                backgroundColor: "#006A6B", // Fill color for points
                pointBackgroundColor: "#006A6B", // Fill color for points
                pointBorderColor: "#006A6B", // Border color for points
                pointBorderWidth: 1, 
              label: 'Systolic',
          });

          // Sort by timestamp first, then convert and sort by x-value
          const sortedDiastolic = [...dataValues.diastolic].sort((a, b) => a.timestamp - b.timestamp);
          let diastolicData = sortedDiastolic.map(entry => ({x:convertToDecimalHours(entry.timestamp*1000,entry.timezone),y:entry.reading,m:entry.timestamp,unit:entry.unit,timezone:entry.timezone}));
          // Sort by x-value (decimal hours) to ensure Chart.js receives data in ascending order
          diastolicData = diastolicData.sort((a, b) => a.x - b.x);
          datasets.push({
              data: diastolicData,
              borderColor: "#CB6A97",
                backgroundColor: "#CB6A97", // Fill color for points
                pointBackgroundColor: "#CB6A97", // Fill color for points
                pointBorderColor: "#CB6A97", // Border color for points
                pointBorderWidth: 1, 
              label: 'Diastolic',
          });
      } else if (dataValues.values) {
          // Sort by timestamp first, then convert and sort by x-value
          const sortedValues = [...dataValues.values].sort((a, b) => a.timestamp - b.timestamp);
          let valuesData = sortedValues.map(entry => ({x:convertToDecimalHours(entry.timestamp*1000,entry.timezone),y:entry.reading,m:entry.timestamp,unit:entry.unit,timezone:entry.timezone}));
          // Sort by x-value (decimal hours) to ensure Chart.js receives data in ascending order
          valuesData = valuesData.sort((a, b) => a.x - b.x);
          datasets.push({
              data: valuesData,
              borderColor: "#CB6A97",
                backgroundColor: "#CB6A97", // Fill color for points
                pointBackgroundColor: "#CB6A97", // Fill color for points
                pointBorderColor: "#CB6A97", // Border color for points
                pointBorderWidth: 1,
              label: label,
          });
      }
  }

  const customTooltip = (context) => {
    let tooltipEl = document.getElementById('chartjs-tooltip');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.id = 'chartjs-tooltip';
        tooltipEl.classList.add('chartjs-tooltip');
        document.body.appendChild(tooltipEl);
    }

    const tooltipModel = context.tooltip;

    if (tooltipModel.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
        tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
        tooltipEl.classList.add('no-transform');
    }

    if (tooltipModel.body) {
        const titleLines = tooltipModel.title || [];
        const bodyLines = tooltipModel.body.map(bodyItem => bodyItem.lines);

        let innerHtml = '<div class="tooltip-title">';
        titleLines.forEach(title => {
            innerHtml += `<div>${tooltipModel.title}</div>`;
        });
        innerHtml += '</div><div class="tooltip-body">';
        bodyLines.forEach(body => {
            innerHtml += `<div>${body}</div>`;
        });
        innerHtml += '</div>';

        tooltipEl.innerHTML = innerHtml;
    }

    const position = context.chart.canvas.getBoundingClientRect();
    tooltipEl.style.opacity = 1;
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.fontFamily = tooltipModel.options.bodyFont.family;
    tooltipEl.style.fontSize = '18px';
    tooltipEl.style.fontStyle = tooltipModel.options.bodyFont.style;
    tooltipEl.style.padding = '10px';
    tooltipEl.style.pointerEvents = 'none';
};


  const options = {
      responsive: true,
    
      plugins: {
        tooltip: {
            enabled: false,
            external: customTooltip,
            callbacks: {
                label: function(context) {
                    let label = context.dataset.label || '';
                    if (label) {
                        label = ``;
                    }
                    if (context.parsed.y !== null) {
                        label = context.parsed.y + (context.raw.unit === 'C' || context.raw.unit === 'F' ? ' °' : ' ') + `${context?.raw?.unit}`;
                    }
                    
                    return (label);
                },
                title: function(tooltipItems) {
                    // Customize the tooltip title based on the dataset label
                    const fulltitle = convertToPatientTimeZoneDateFormat(tooltipItems[0].raw?.["m"],dateformat,tooltipItems[0]?.raw?.timezone);
              
                    let title = fulltitle.split(" ").slice(1, 3).join(" ");
                    // Replace 12:XX AM with 00:XX AM (midnight display)
                    // Handles formats like "12:00:00 AM", "12:45:00 AM", "12:00 AM", "12:45 AM"
                    title = title.replace(/^12:(\d{1,2})(:(\d{1,2}))?\s*AM/i, (match, minutes, colonSeconds, seconds) => {
                        if (colonSeconds && seconds) {
                            return `00:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')} AM`;
                        }
                        return `00:${minutes.padStart(2, '0')} AM`;
                    });
                    return title; // Return the dataset label as the title
                  },
            }
        },
        legend: {
            display: false // Hide the legend
        }
    },

      scales: {
          x: {
              type: 'linear',
              position: 'bottom',
              min: 0,
              max: 24,
              ticks: {
                  stepSize: 2,
                  callback: function (value) {
                      return value % 2 === 0 ? value : '';
                  },
              },
              title: {
                  display: true,
                  text: 'Hours',
              },
              time: {
                  unit: 'hour',
                  displayFormats: {
                      hour: 'HH:mm'
                  }
              }
          },
          y: {
              title: {
                  display: true,
                  text: 'Readings',
              },
              ticks: {
                stepSize: 1, // Ensure a difference of at least 1
                callback: function(value) {
                    if(from==='blood_glucose'){
                        return value.toFixed(2); 
                    }else if(from==='temperature'||from==='weight'){
                        return value.toFixed(1)
                    }else{
                        return value
                    }
                 // Format the y-axis values to 2 decimal places
                },
                
            }
          },

      },
  };

  return (
      <>
          {from==='blood_pressure'?(graphDetails?.[from]?.systolic?.length>0||graphDetails?.[from]?.diastolic?.length>0)?
              <Line
                  data={{
                      datasets: datasets,
                  }}
                  options={options}
              /> :
              <div className='2xl:h-[355px] tm:h-[270px] xl:h-[250px] h-[220px] text-center flex items-center justify-center text-xl'>No Readings Found</div>:graphDetails?.[from]?.values?.length>0?
              <Line
                  data={{
                      datasets: datasets,
                  }}
                  options={options}
              /> :
              <div className='2xl:h-[355px] tm:h-[270px] xl:h-[250px] h-[220px] text-center flex items-center justify-center text-xl'>No Readings Found</div>
            }
      </>

  );
}
